module.exports = __webpack_public_path__ + "static/banner-1-975af67ff2a4d7634d300e27f59f0e5f.jpg";